<div class="row space-between">
  <rr-icon name="key" class="roundicon" color="nutral"></rr-icon>
  <rr-icon name="close" color="nutral" class="icon" (click)="close()"></rr-icon>
</div>

<div class="col gap-8">
  <h2 i18n>Key Results</h2>
  <div i18n>Here you can view and manage your results.</div>
</div>

<rr-segment-control
  size="small"
  (selectionChange)="switchActiveContent($event)"
>
  <rr-segment-control-item name="Qualify"> </rr-segment-control-item>
  <rr-segment-control-item name="Validate"> </rr-segment-control-item>
  <rr-segment-control-item name="Ship"> </rr-segment-control-item>
</rr-segment-control>

<div class="spacer"></div>
<div class="col w100 scroll gap-16">
  <section class="col w100">
    <h3 i18n #qualify id="qualify">Qualify</h3>
    <div class="spacer"></div>
    <div class="col gap-8 w100">
      <app-key-result-item
        label="Main Persona"
        [status]="mainPersonaStatus"
        [value]="mainPersona"
        (createClicked)="goto('J1S-8At2nL', 'Ci6Ju_grd')"
        (showClicked)="openPdfPreview(mainPersonaData)"
      ></app-key-result-item>
      <app-key-result-item
        label="User Empathy Map"
        [status]="emapthyMapStatus"
        [value]="emapthyMap"
        (createClicked)="goto('J1S-8At2nL', 'jKHo2wIzi')"
        (showClicked)="openPdfPreview(emapthyMapData)"
      ></app-key-result-item>
      <app-key-result-item
        label="Landing Page (Optional)"
        [status]="landingPageStatus"
        [value]="landingPage"
         (createClicked)="goto('J1S-4dXLpB4Ll', 'closing-stream')"
        (showClicked)="openLandingPage()"
      ></app-key-result-item>
      <app-key-result-item
        label="Elevator Pitch"
        [status]="elevatorPitchStatus"
        [value]="elevatorPitch"
        (createClicked)="goto('J1S-4dXLpB4Ll', 'closing-stream')"
        (showClicked)="openPdfPreview(elevatorPitchData)"
      ></app-key-result-item>
    </div>
  </section>
  <section class="col w100">
    <h3 i18n id="validate" #validate>Validate</h3>
    <div class="spacer"></div>
    <div class="col gap-8 w100">
      <app-key-result-item
        label="Market Potential Report"
        [status]="marketReportStatus"
        [value]="marketReport"
        (createClicked)="openFeedbackPinDashbord()"
        (showClicked)="openPdfPreview(marketReportData)"
      ></app-key-result-item>
      <app-key-result-item
        label="Competitor Report"
        [status]="competitorReportStatus"
        [value]="competitorReport"
        (createClicked)="openFeedbackPinDashbord()"
        (showClicked)="openPdfPreview(competitorReportData)"
      ></app-key-result-item>
      <app-key-result-item
        label="User Validation Report"
        [status]="userValiReportStatus"
        [value]="userValiReport"
        (createClicked)="openFeedbackPinDashbord()"
        (showClicked)="openPdfPreview(userValiReportData)"
      ></app-key-result-item>
      <app-key-result-item
        label="Mentor Feedback Report"
        [status]="mentorFeedbackReportStatus"
        [value]="mentorFeedbackReport"
        (createClicked)="openFeedbackPinDashbord()"
        (showClicked)="openPdfPreview(mentorFeedbackReportData)"
      ></app-key-result-item>
    </div>
  </section>
  <section class="col w100">
    <h3 i18n id="ship" #ship>Ship</h3>
    <div class="spacer"></div>
    <div class="col gap-8 w100">
      <app-key-result-item
        label="Business Model DNA"
        [status]="bmcStatus"
        [value]="bmc"
        (showClicked)="openPdfPreview(bmcData)"
      ></app-key-result-item>
      <app-key-result-item
        label="Business Plan"
        [status]="businessPlanStatus"
        [value]="businessPlan"
      ></app-key-result-item>
      <app-key-result-item
        label="Go-To-Market Strategy"
        [status]="goToMarketStrategyStatus"
        [value]="goToMarketStrategy"
      ></app-key-result-item>
      <app-key-result-item
        label="Product Roadmap"
        [status]="productRoadmapStatus"
        [value]="productRoadmap"
      ></app-key-result-item>
    </div>
  </section>
</div>
